import { render, staticRenderFns } from "./RziSideLists.vue?vue&type=template&id=3164dd88&scoped=true&"
import script from "./RziSideLists.vue?vue&type=script&lang=js&"
export * from "./RziSideLists.vue?vue&type=script&lang=js&"
import style0 from "./RziSideLists.vue?vue&type=style&index=0&id=3164dd88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164dd88",
  null
  
)

export default component.exports